// Small pricing display block used on treatment cards and product pages.
// Renders as two lines:
//   $X/month
//   <suffix, e.g. "3-month plan">
// If pricing.cardSuffix is an empty string, the product is treated as
// monthly-only (e.g. B12) and displays only "$X/month" without a second line.

const PRICE_SIZE_CLASSES = {
  sm: "text-sm md:text-base",
  md: "text-base md:text-lg",
  lg: "text-xl md:text-2xl",
};

const SUFFIX_SIZE_CLASSES = {
  sm: "text-[10px] md:text-[11px]",
  md: "text-[11px] md:text-xs",
  lg: "text-xs md:text-sm",
};

const NOTE_SIZE_CLASSES = {
  sm: "text-[9px] md:text-[10px]",
  md: "text-[10px] md:text-[11px]",
  lg: "text-[10px] md:text-[11px]",
};

export default function PriceLine({
  treatment,
  size = "md",
  align = "left",
  testId,
  showFinePrint = true,
  showNote = true,
  className = "",
}) {
  const pricing = treatment?.pricing;
  if (!pricing) return null;

  const price = pricing.startingAt;
  const cardSuffix = pricing.cardSuffix;
  // Monthly-only products (e.g. B12) use an empty-string cardSuffix.
  const monthlyOnly = cardSuffix === "";
  const suffixText = monthlyOnly
    ? null
    : cardSuffix || "3-month plan";
  const alignClass = align === "center" ? "text-center" : "text-left";

  const priceSize = PRICE_SIZE_CLASSES[size] || PRICE_SIZE_CLASSES.md;
  const suffixSize = SUFFIX_SIZE_CLASSES[size] || SUFFIX_SIZE_CLASSES.md;
  const noteSize = NOTE_SIZE_CLASSES[size] || NOTE_SIZE_CLASSES.md;

  return (
    <div
      data-testid={testId || `price-${treatment.slug}`}
      className={`${alignClass} ${className}`}
    >
      <p className={`${priceSize} font-display font-semibold text-[#2C2B29] leading-tight`}>
        <span className="text-[#C96A4E]">${price}</span>
        <span className="text-[#2C2B29]">/month</span>
      </p>
      {suffixText && (
        <p className={`mt-0.5 font-normal text-[#8A9A92] ${suffixSize} leading-snug`}>
          {suffixText}
        </p>
      )}
      {showNote && pricing.note && (
        <p
          data-testid={`price-note-${treatment.slug}`}
          className={`mt-1 ${noteSize} text-[#5E5C58] leading-snug`}
        >
          {pricing.note}
        </p>
      )}
      {showFinePrint && (
        <p className={`mt-1 ${noteSize} text-[#8A9A92] leading-snug`}>
          Prescription required. Not all patients qualify. Results vary.
        </p>
      )}
    </div>
  );
}
